import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';

import { Grid, Button } from '@material-ui/core';
import { DateTimePicker } from '@material-ui/pickers';

import { InputField } from '..';
import { useStyles } from './styles.js';

const inputLabelProps = {
  shrink: true,
  style: { fontSize: 20, top: '-5px', fontWeight: 'bold' },
};

class Chapter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quarter_number: props.current_tab,
      quarter_name:
        props.chapter_settings &&
        props.chapter_settings[props.current_tab] &&
        props.chapter_settings[props.current_tab]['game_settings'].quarter_name,
      quarter_start_date:
        props.chapter_settings &&
        props.chapter_settings[props.current_tab] &&
        props.chapter_settings[props.current_tab]['game_settings']
          .quarter_start_date,
      quarter_end_date:
        props.chapter_settings &&
        props.chapter_settings[props.current_tab] &&
        props.chapter_settings[props.current_tab]['game_settings']
          .quarter_end_date,
      duplicate_chapters: props.duplicate_chapters,
    };
  }

  /** LIFE CYCLE METHODS */
  componentDidMount() {
    console.log(this.props);
  }

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  getLabel(name, classes) {
    let labelJsx = [];
    labelJsx.push(
      <label>
        {' '}
        {name}
        <span className={classes.requiredAsterisk}> *</span>
      </label>,
    );
    return labelJsx;
  }

  /**RENDER METHOD */
  render() {
    const { classes } = this.props;
    console.log(this.props.current_tab);
    return (
      <Grid>
        <Grid container className={classes.gridContainer}>
          <Grid item md={6} xs={12} className={classes.gridItem}>
            <InputField
              id="quarter_name"
              name="quarter_name"
              label="Chapter Name"
              placeholder={'Chapter Name'}
              onChange={this.handleChange}
              className={classes.field}
              value={this.state.quarter_name}
            />
          </Grid>

          <Grid item md={6} xs={12} className={classes.gridItem}>
            <DateTimePicker
              variant="inline"
              format="MM/DD/YYYY hh:mm A"
              name="quarter_start_date"
              label={this.getLabel('Chapter Start Date', classes)}
              InputLabelProps={inputLabelProps}
              className={classes.field}
              value={this.state.quarter_start_date}
              onChange={date => this.setState({ quarter_start_date: date })}
            />
          </Grid>

          <Grid item md={6} xs={12} className={classes.gridItem}>
            <DateTimePicker
              variant="inline"
              format="MM/DD/YYYY hh:mm A"
              name="quarter_end_date"
              label={this.getLabel('Chapter End Date', classes)}
              InputLabelProps={inputLabelProps}
              className={classes.field}
              value={this.state.quarter_end_date}
              onChange={date => this.setState({ quarter_end_date: date })}
            />
          </Grid>
        </Grid>
        <Button
          color="primary"
          type="button"
          variant="contained"
          onClick={e => this.props.onClick({ game_settings: this.state })}
        >
          Next
        </Button>
      </Grid>
    );
  }
}

Chapter.propTypes = {
  className: PropTypes.string,
};

export default withStyles(useStyles)(Chapter);
